import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SeoPage = lazy(() => import('../pages/seo/page'));
const SocialMediaPage = lazy(() => import('../pages/social-media/page'));
const PPCMarketingPage = lazy(() => import('../pages/ppc-marketing/page'));
const EcommercePage = lazy(() => import('../pages/e-commerce/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AnalysisPage = lazy(() => import('../pages/analysis/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Create a wrapper component for lazy loaded components with Suspense
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LazyWrapper><HomePage /></LazyWrapper>,
  },
  {
    path: '/seo-optimisation',
    element: <LazyWrapper><SeoPage /></LazyWrapper>,
  },
  {
    path: '/social-media-management',
    element: <LazyWrapper><SocialMediaPage /></LazyWrapper>,
  },
  {
    path: '/ppc-marketing',
    element: <LazyWrapper><PPCMarketingPage /></LazyWrapper>,
  },
  {
    path: '/e-commerce',
    element: <LazyWrapper><EcommercePage /></LazyWrapper>,
  },
  {
    path: '/contact',
    element: <LazyWrapper><ContactPage /></LazyWrapper>,
  },
  {
    path: '/analysis',
    element: <LazyWrapper><AnalysisPage /></LazyWrapper>,
  },
  {
    path: '*',
    element: <LazyWrapper><NotFound /></LazyWrapper>,
  },
];

export default routes;
